/**
 * Shared subscription plan definitions for frontend components.
 * This is the single source of truth for all plan data (pricing, duration, display).
 * Both OnboardingPage and ProfilePage import from here.
 */
export interface Plan {
  price: number;
  originalPrice?: number; // Harga asli sebelum promo (untuk strikethrough)
  days: number;
  label: string;
  desc: string;
  perHari: string;
  badge: string | null;
  promoLabel?: string; // Label promo tambahan
}

export const PLANS: Record<string, Plan> = {
  daily:   { price: 1000,  originalPrice: undefined, days: 1,  label: 'Harian',  desc: '1 Hari',  perHari: 'Rp 1.000/hari', badge: null },
  weekly:  { price: 7000,  originalPrice: undefined, days: 7,  label: '7 Hari',  desc: '7 Hari',  perHari: 'Rp 1.000/hari', badge: null },
  monthly: { price: 30000, originalPrice: 100000,    days: 30, label: 'Bulanan', desc: '30 Hari', perHari: 'Rp 1.000/hari', badge: 'PROMO', promoLabel: 'Hemat 70%!' },
};

export const DEFAULT_PLAN = 'monthly';
